/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFunktionDetailDto } from '../../models/lexplus-funktion-detail-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface FunktionenControllerCreateV1$Params {
      body: LexplusFunktionDetailDto
}

export function funktionenControllerCreateV1(http: HttpClient, rootUrl: string, params: FunktionenControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

funktionenControllerCreateV1.PATH = '/v1/funktionen';
